import { Extension } from "@tiptap/core";
import { history, undo, redo, historyKey } from "./prosemirror-history";

export interface HistoryOptions {
  depth: number;
  newGroupDelay: number;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    history: {
      /**
       * Undo recent changes
       */
      undo: () => ReturnType;
      /**
       * Reapply reverted changes
       */
      redo: () => ReturnType;
    };
  }
}

export const History = Extension.create<HistoryOptions>({
  name: "history",

  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 10,
    };
  },

  addCommands() {
    return {
      undo:
        () =>
        ({ state, dispatch }) => {
          return undo(state, dispatch);
        },
      redo:
        () =>
        ({ state, dispatch }) => {
          return redo(state, dispatch);
        },
    };
  },

  addProseMirrorPlugins() {
    return [history(this.options)];
  },
});
